export default "__VITE_ASSET__BNgJ5fLE__"